import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Form, Header, Label, Segment } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
// import { MasterOptions } from "../../app/common/options/countrystateOptions/languageOptions";
import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';
import { store, useStore } from './../../app/stores/store';
// import MySelectInput from "./../../app/common/form/MySelectInput";

import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useEffect, useState } from 'react';
import { WorkLevel, WorkLevelInitialData } from '../../app/models/workLevel';
// import { getYear } from "date-fns";
import LoadingComponent from './../../app/layout/LoadingComponent';
// import DatePicker from "react-datepicker";
import sendRespectiveEmail from '../../app/models/EmailNew';
import UnauthorizedMessage from '../UnauthorizedMessage';

function WorkLevelMasterForm() {
  const { WorkLevelStore, modalStore, dashboardStore, commonStore } =
    useStore();
  const {
    createWorkLevel,
    updateWorkLevel,
    selectedworkLevel,
    loadingInitial,
    loadAllMasterTitles,
    loadAllMastersTitleDetails,
  } = WorkLevelStore;
  // const [yearString, setYearString] = useState("");
  const [workLevelData, setWorkLevelData] =
    useState<WorkLevel>(WorkLevelInitialData);
  const [showValidationError, setShowValidationError] = useState(false);

  useEffect(() => {
    loadAllMasterTitles();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      // updating
      selectedworkLevel?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedworkLevel,
      };
      setWorkLevelData(newArr);
      // setYearString(newArr.year);
    }
    // eslint-disable-next-line
  }, [selectedworkLevel]);

  const handleSubmit = (values: any) => {
    if (values.id === '') {
      const newworkLevelData = {
        ...values,
        id: uuid(),
      };

      createWorkLevel(newworkLevelData);
      sendRespectiveEmail(
        'created',
        newworkLevelData.title,
        'Created Worklevel',
        '',
      ); //email Function
      store.WorkLevelStore.selectedworkLevel = undefined;
      dashboardStore.dashboard.formikClearFormBool = false;
      // ------------------>call an api to create master under asset type;
    } else {
      const newworkLevelData = {
        ...values,
      };
      updateWorkLevel(newworkLevelData); // update
      sendRespectiveEmail(
        'edited',
        newworkLevelData.title,
        'Created Worklevel',
        '',
      ); //email Function
      store.WorkLevelStore.selectedworkLevel = undefined; // setting the state to initial value for form reset
      dashboardStore.dashboard.formikClearFormBool = false; // setting the state to initial value for form reset
    }
    modalStore.closeModal(); //close modal
    setWorkLevelData(WorkLevelInitialData); //setting the state to initial value for form reset
  };

  //------------------------------->handle Cancel
  const handleCancel = () => {
    setWorkLevelData(WorkLevelInitialData); //------------------>handle Cancelsetting the state to initial value for form reset
    modalStore.closeModal(); //close modal
    dashboardStore.dashboard.formikClearFormBool = false;
    store.WorkLevelStore.selectedworkLevel = undefined; //setting the state to initial value for form reset
  };
  //------------------------------->handle Change

  const handleChange = (e: any, data: any) => {
    if (data === undefined) {
      const newArr = {
        ...workLevelData,
        [e.target.name]: e.target.value,
      };
      setWorkLevelData(newArr);

      if (!loadAllMastersTitleDetails.includes(e.target.value.toLowerCase())) {
        setShowValidationError(false);
      } else {
        setShowValidationError(true);
      }
    } else {
      const newArr = {
        ...workLevelData,
        isMaster: data.checked,
      };
      setWorkLevelData(newArr);
    }
  };

  ///////////////////handle Year Change
  // const handleYearChange = (e: any) => {
  //   setYearString(getYear(e).toString());
  // };

  if (loadingInitial) return <LoadingComponent />;
  return (
    <div id="parent-grid-shelf" className="largeScreen smallScreen">
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne.includes('AWLB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('AWLB01') && (
        <Segment clearing className="shelf-form-segment" responsive={true}>
          <Header
            icon="edit"
            size="huge"
            dividing
            as="h1"
            content="Item Group Master"
            sub
            color="grey"
          />
          <Formik
            initialValues={workLevelData}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              handleSubmit(values);
              resetForm();
            }}
            validationSchema={Yup.object({
              title: Yup.string().required('Please specify a title'),
            })}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form
                className="ui form error"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <Form.Group widths="equal">
                  <MyTextInput
                    value={workLevelData.title}
                    onChange={handleChange}
                    name="title"
                    placeholder="Title"
                    label="Title"
                  />
                </Form.Group>
                {showValidationError && (
                  <Label basic color="red">
                    Master Name Already exists
                  </Label>
                )}
                <Form.Group widths="equal">
                  <Form.Checkbox
                    label="isMaster"
                    checked={workLevelData.isMaster}
                    name="isMaster"
                    onChange={handleChange}
                  />
                </Form.Group>
                <Button.Group floated="right" style={{ marginTop: '40px' }}>
                  <Button type="reset" onClick={handleCancel}>
                    {
                      (userLanguage[0].AssetWorkLevelMaster?.AWLB01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Button>{' '}
                  <Button.Or
                    text={
                      (userLanguage[0].AssetWorkLevelMaster?.AWLB02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  />
                  <Button
                    loading={isSubmitting}
                    type="submit"
                    content="Submit"
                    positive
                    disabled={showValidationError}
                  >
                    {
                      (userLanguage[0].AssetWorkLevelMaster?.AWLB03 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }{' '}
                  </Button>
                </Button.Group>
              </Form>
            )}
          </Formik>
        </Segment>
      )}
    </div>
  );
}

export default observer(WorkLevelMasterForm);
